<template>
  <ExportHistory product="crm" feature="CRM_EXPORT_HISTORY" />
</template>

<script>
import ExportHistory from "components/src/export-history.vue";

export default {
  props: {
    module: String,
    product: String,
  },
  components: {
    ExportHistory,
  },
};
</script>
